import styled from "styled-components";

import { theme } from "../../../../styles/theme";

export const Container = styled.button`
  margin: 0;
  font-size: ${theme.font.sizes.normal};
  font-family: ${theme.font.poppins};
  font-style: normal;
  font-weight: 400;
  text-align: right;
  letter-spacing: 0.2px;
  color: ${theme.colors.white};
  background: none;
  cursor: pointer;
`;
